import styled from 'styled-components';

import { fontStyles } from 'theme';

const Text = styled.p`
  ${fontStyles.text}
`;
const Slogan = styled.h1`
  ${fontStyles.slogan}
`;
const Title = styled.h2`
  ${fontStyles.title}
`;
const TitleH3 = styled.h3`
  ${fontStyles.titleH3}
`;
const TitleH4 = styled.h4`
  ${fontStyles.titleH4}
`;
const Upper = styled.p`
  ${fontStyles.textUpper}
`;
const Small = styled.p`
  ${fontStyles.smallText}
`;

Text.Slogan = Slogan;
Text.Title = Title;
Text.TitleH3 = TitleH3;
Text.TitleH4 = TitleH4;
Text.Upper = Upper;
Text.Small = Small;

export default Text;
